module.exports = __webpack_public_path__ + "static/img/ico-viacredi.79b8c55.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/bancos/ico-viacredi.png
// module id = rhLV
// module chunks = 0